import React, { Fragment } from 'react'
import Configurator from '../../configurator'
import {
    API_CHECKER_STATUS_ONLINE,
    S_SPORTNECT,
} from '../../consts'
import {
    getUrlParameter,
    isWebView,
} from '../../admin/actions'
import logout from '../../admin/actions/logout'
import { cognitoUserHasEmail } from '../../admin/actions/auth-new'
import BrowserBar from '../../components/browser-bar'
import SmartBanner from '../../components/smart-banner'
import Loader from '../../front/components/shared/loader'
import FullNameMissing from '../../components/full-name-missing'
import EmailMissing from '../../components/email-missing'
import {
    BrowserRouter as Router,
    Route,
} from 'react-router-dom'
import FrontRoutes from '../front'
import AdminRoutes from '../admin'
import SuperAdminRoutes from '../super-admin'
import CSTranslatedRoutes from '../cs-translated'
import GlobalRoutes from '../global'
import { Helmet } from 'react-helmet'
import OnBoarding from '../../components/on-boarding'
import SystemRedirect from '../../components/system-redirect'
import NotFound from '../../components/404'
import { withConnectWrapper } from '../../validator'
import ApiOffline from '../../components/api-checker/api-offline'
import PromoBanner from '../../components/promo-banner/promo-banner'

class Routes extends Configurator {
    constructor(props) {
        super(props)

        if (this.isIndexHtml()) {
            const locale = this.props.locale || ''
            window.location.href = `${locale}/`
        }
    }

    /**
     * Check if current pathname is /index.html
     * @returns {boolean}
     */
    isIndexHtml = () => {
        const locale = this.props.locale || ''
        return window.location.pathname === `${locale}/index.html`
    }

    /**
     * Return true, if system is Sportnect
     * @returns {boolean}
     */
    isSportnectSystem = () => this.config.REACT_APP_SYSTEM === S_SPORTNECT

    /**
     * Check if user has email
     * @param {Object} auth
     * @return {boolean}
     */
    userHasEmail = auth => {
        if (!auth.user) {
            return true
        }

        return !!auth.user.email
    }

    /**
     * Check if user has email
     * @param {Object} auth
     * @return {boolean}
     */
    userHasFullName = auth => {
        if (!auth.user) {
            return true
        }

        const userHasName = auth.user.name && auth.user.name?.length
        const userHasSurname = auth.user.surname && auth.user.surname?.length

        return userHasName && userHasSurname
    }

    /**
     * Checks logged user id on coming to sportnect from mail client
     * @param {Object} auth authorized user object
     */
    checkLoggedUserSlug = auth => {
        if (!auth?.user || auth?.fetchingAuthedUser) {
            return
        }

        const userSlug = getUrlParameter('toSlug')

        if (userSlug && auth?.user?.slug !== userSlug) {
            logout()
        }
    }

    /**
     * Returns true, if route is not found in any routes
     * @returns {boolean}
     */
    isRouteNotFound = () => {
        const {
            notFoundRoutes: {
                frontRoutes,
                adminRoutes,
                superAdminRoutes,
                translatedRoutes: notFoundedInCities,
                globalRoutes: notFoundedInGlobal,
            },
        } = this.props

        const isSportnect = this.isSportnectSystem()
        const notFoundedInSportnect = frontRoutes && adminRoutes && superAdminRoutes

        return notFoundedInGlobal && ((isSportnect && notFoundedInSportnect) || (!isSportnect && notFoundedInCities))
    }

    /**
     * Render
     *
     * @return {*}
     */
    render = () => {
        const {
            REACT_APP_SYSTEM_NAME: defaultTitle,
            REACT_APP_DEFAULT_DESCRIPTION: defaultDescription,
        } = this.config

        const {
            auth,
            heading,
            systemRedirect,
            isNotOnboardingFinished,
            apiStatus,
        } = this.props


        if (apiStatus && apiStatus !== API_CHECKER_STATUS_ONLINE) {
            return (
                <ApiOffline />
            )
        }

        const locale = this.props.locale || ''

        const isFetchingAuth = auth?.fetchingAuthedUser
        const isLogged = auth?.user
        const routeNotFound = this.isRouteNotFound()
        const userHasEmail = this.userHasEmail(auth) && cognitoUserHasEmail()
        const userHasFullName = this.userHasFullName(auth)

        const smartsupp = document.getElementById('chat-application')

        if (smartsupp && isWebView()) {
            smartsupp.style.display = 'none'
        }

        this.checkLoggedUserSlug(auth)

        return (
            <Fragment>
                <BrowserBar />

                <SmartBanner />

                <PromoBanner />

                {isFetchingAuth &&
                    <div className="d-flex flex-column flex-fill">
                        <Loader />
                    </div>
                }

                {!isFetchingAuth && !userHasFullName &&
                    <FullNameMissing />
                }

                {!isFetchingAuth && !userHasEmail &&
                    <EmailMissing />
                }

                {!isFetchingAuth && userHasEmail && userHasFullName &&
                    <Router basename={this.isSportnectSystem() ? locale : ''}>
                        <FrontRoutes />
                        <AdminRoutes />
                        <SuperAdminRoutes />
                        <CSTranslatedRoutes />
                        <GlobalRoutes />

                        <Helmet>
                            <title>{heading?.title || (defaultTitle + ' | ' + defaultDescription)}</title>
                            <meta name="description" content={heading?.description || defaultDescription} />
                        </Helmet>

                        {isLogged && !isWebView() && this.isSportnectSystem() && (isNotOnboardingFinished) && <OnBoarding />}

                        {(systemRedirect?.backLink || systemRedirect?.forwardLink) && <SystemRedirect />}

                        {routeNotFound && !this.isIndexHtml() && <Route component={NotFound} />}
                    </Router>
                }
            </Fragment>
        )
    }
}

export default withConnectWrapper(state => ({
    auth: state.auth,
    pageHeader: state.pageHeader,
    systemRedirect: state.systemRedirect,
    isNotOnboardingFinished: !state.auth?.isOnBoardingCompletly,
    notFoundRoutes: state.notFoundRoutes,
    apiStatus: state.apiChecker.status,
}))(Routes)
